import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTH_CONFIG_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_AUTH_CONFIG_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_AUTH_CONFIG_REDIRECT_URL,
  response_type: process.env.REACT_APP_COGNITO_AUTH_CONFIG_RESPONSE_TYPE,
  scope: process.env.REACT_APP_COGNITO_AUTH_CONFIG_SCOPE,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

